import { Filter, Trash2 } from 'lucide-react';
import React from 'react';

/**
 * Results Header Component
 * Based on conversation-mockup.html design
 * Header with job info, bulk selection, and filter
 *
 * @param {Object} props
 * @param {string} props.jobTitle - Job title
 * @param {number} props.totalCount - Total candidates
 * @param {number} props.showingCount - Currently showing
 * @param {boolean} props.selectAll - Select all state
 * @param {Function} props.onSelectAllChange - Select all callback
 * @param {number} props.selectedCount - Number of selected candidates
 * @param {Function} props.onBulkRemove - Bulk remove callback
 * @param {Function} props.onFilter - Filter callback
 */
export function ResultsHeader({
  jobTitle = 'Search Results',
  totalCount = 0,
  showingCount = 0,
  selectAll = false,
  onSelectAllChange,
  selectedCount = 0,
  onBulkRemove,
  onFilter
}) {
  const displayCount = showingCount > 0 ? showingCount : totalCount;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="font-semibold text-gray-900 text-lg">{jobTitle}</h3>
            <p className="text-sm text-gray-500">
              {totalCount} candidates found
              {showingCount > 0 && showingCount < totalCount && ` • Showing top ${showingCount}`}
            </p>
          </div>
          {onFilter && (
            <button
              onClick={onFilter}
              className="px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium hover:bg-gray-50 transition flex items-center gap-2"
            >
              <Filter className="w-4 h-4" />
              Filter
            </button>
          )}
        </div>

        {/* Bulk Selection Bar */}
        <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200">
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              id="selectAll"
              checked={selectAll}
              onChange={(e) => onSelectAllChange && onSelectAllChange(e.target.checked)}
              className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
            />
            <label
              htmlFor="selectAll"
              className="text-sm font-medium text-gray-700 cursor-pointer"
            >
              Select All
            </label>
            <span className="text-xs text-gray-500">
              ({selectedCount} selected)
            </span>
          </div>
          {selectedCount > 0 && (
            <button
              onClick={onBulkRemove}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition text-sm font-medium flex items-center gap-2"
            >
              <Trash2 className="w-4 h-4" />
              Remove Selected
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResultsHeader;























